<template>
  <div class="bootCard-bd tb" v-if="funcView.card_list">
    <div class="search-hd">
      <el-form :inline="true">
        <el-form-item v-if="funcView.card_add">
          <el-button type="primary" @click="addCard">
            <i class="icon icon-add"></i>
            {{ funcView.card_add }}
          </el-button>
        </el-form-item>
        <el-form-item v-if="funcView.card_import">
          <el-button type="primary" @click="addBatchStock">
            <i class="icon icon-piliangtianjia"></i>
            {{ funcView.card_import }}
          </el-button>
        </el-form-item>
        <!-- 导出 -->
        <el-form-item style="float: right; margin-right: 0" v-if="funcView.card_export">
          <el-dropdown>
            <el-button class="table-set" style="vertical-align: top" @click.native="exportTable('bootCardExport', formSearch)"><i class="icon icon-daochu"></i></el-button>
          </el-dropdown>
        </el-form-item>
        <!-- 配置项 -->
        <el-form-item style="float: right">
          <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('dms_bootCard.RFIDkmbhbz')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container ref="container" @search="getbootCradList" @clear="clearFilter()">
      <el-form :inline="true" label-position="top">
        <el-form-item :label="$t('dms_bootCard.ji_shen_hao')">
          <el-input v-model="formSearch.bodyNum"></el-input>
        </el-form-item>
        <el-form-item :label="$t('dms_bootCard.gxsjd')">
          <custom-date-picker
            style="width: 100%"
            v-model="formSearch.gmtModified"
            type="daterange"
            :picker-options="beforeToday"
            value-format="YYYY-MM-DD HH:mm:ss"
            :start-placeholder="$t('dms_bootCard.kai_shi_ri_qi')"
            :end-placeholder="$t('dms_bootCard.jie_shu_ri_qi')"
          ></custom-date-picker>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table :index="true" :column="tableColumn" :data="bootCardList" :slots="['cardNum', 'action']" height="100%" @filter="filterChange" @sort="sortChange">
        <template slot="cardNum" slot-scope="scope">
          <span v-if="funcView.card_preview" class="cell-link" @click="seeBootCard(scope.row.cardId)">
            {{ scope.row.cardNum }}
          </span>
          <span v-else>{{ scope.row.cardNum }}</span>
        </template>
        <template slot="action" slot-scope="scope">
          <span></span>
          <el-button type="text" size="mini" v-if="funcView.card_edit" @click="editBootCard(scope.row.cardId)">{{ funcView.card_edit }}</el-button>
          <el-button type="text" size="mini" v-if="funcView.card_delete" @click="deleteBootcard(scope.row)">{{ funcView.card_delete }}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <bootCard-add-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onPageChange({ page: 1 })"></bootCard-add-dialog>
    <bootCard-batch-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="onPageChange({ page: 1 })"></bootCard-batch-dialog>
    <bootCard-item-dialog v-if="dialogVisible2" :model="dialogModel2" @close="dialogVisible2 = false" @success="onPageChange({ page: 1 })"></bootCard-item-dialog>
    <!-- 查看 -->
    <bootCard-see-dialog v-if="dialogVisible3" :model="dialogModel3" @close="dialogVisible3 = false"></bootCard-see-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import bootCardAddDialog from './children/bootCard_add_dialog';
import bootCardItemDialog from './children/bootCard_item_dialog';
import bootCardBatchDialog from './children/bootCard_batch_dialog';
import bootCardSeeDialog from './children/bootCard_see_dialog';

export default {
  name: 'bootCard',
  mixins: [resetFormSearchMixins],
  components: {
    bootCardAddDialog,
    bootCardBatchDialog,
    bootCardItemDialog,
    bootCardSeeDialog,
  },
  data() {
    return {
      tableCode: 'device_card_manage',
      provide: true,
      // 新增
      dialogVisible: false,
      dialogModel: {},
      // 入库
      dialogVisible1: false,
      dialogModel1: {},

      // 编辑
      dialogVisible2: false,
      dialogModel2: {},

      // 查看
      dialogVisible3: false,
      dialogModel3: {},

      dataTimes: [],
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        search: '',
        shipmentNum: '',
        inUser: '',
        bodyNum: '',
        gmtModified: '',
      },
      bootCardList: [],
      totalRows: 0,
      link: null,
    };
  },
  mounted: function () {
    this.getTableColumn();
    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    this.getbootCradList();
  },
  methods: {
    getReqData() {
      const ret = { ...this.formSearch };
      if (this.formSearch.gmtModified.length) {
        ret.startTime = this.formSearch.gmtModified[0];
        ret.endTime = this.formSearch.gmtModified[1];
        delete ret.gmtModified;
      }
      return ret;
    },
    getbootCradList: function () {
      this.$getJSON(apis.bootCardPage, this.getReqData()).then((res) => {
        this.bootCardList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    addCard: function () {
      this.dialogVisible = true;
    },
    editBootCard: function (cardId) {
      this.dialogVisible2 = true;
      this.dialogModel2.title = this.$t('dms_bootCard.bian_ji_kai_ji_ka');
      this.dialogModel2.type = 'edit';
      this.dialogModel2.cardId = cardId;
    },
    seeBootCard: function (cardId) {
      this.dialogVisible3 = true;
      this.dialogModel3.title = this.$t('dms_bootCard.cha_kan_kai_ji_ka');
      this.dialogModel3.type = 'see';
      this.dialogModel3.cardId = cardId;
    },
    addBatchStock: function () {
      this.dialogVisible1 = true;
    },
    deleteBootcard: function (data) {
      const tips = this.$t('dms_bootCard.nqdyscxzdkjkm');
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.bootCardDelete}/${data.cardId}`, {}, true).then(() => {
            this.$message({
              message: this.$t('Common.com_handle_success'),
              type: 'success',
            });
            this.getbootCradList();
          });
        })
        .catch(() => {});
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getbootCradList();
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'style/colors.scss';

.bootCard-bd {
}
</style>
